import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, X, Expand } from "lucide-react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Reveal } from "@/components/Reveal";
import { getSettings, mediaUrl } from "@/lib/api";

export const Gallery = ({ showHeader = true }) => {
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const items = (settings && settings.gallery_items && settings.gallery_items.length
    ? settings.gallery_items
    : ((settings && settings.gallery) || []).map((u, i) => ({ id: `g-${i}`, url: u, thumb_url: u, alt: "" })));
  const images = items.map((it) => mediaUrl(it.url));
  const thumbs = items.map((it) => mediaUrl(it.thumb_url || it.url));
  const alts = items.map((it, i) => it.alt || `Düğün fotoğrafı ${i + 1}`);
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = (i) => {
    setIndex(i);
    setOpen(true);
  };
  const prev = () => setIndex((i) => (i - 1 + images.length) % images.length);
  const next = () => setIndex((i) => (i + 1) % images.length);

  return (
    <section id="galeri" className="section-pad bg-[#0E0F10]">
      <div className="container-lux">
        {showHeader && (
          <Reveal>
            <div className="text-center max-w-2xl mx-auto">
              <span className="eyebrow justify-center">Galeri</span>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F7F2E8] mt-3">
                Gerçek çiftler, gerçek anlar
              </h2>
              <p className="text-[#9A9387] mt-4">
                “Biz poz veremeyiz” diyenlere özel; sizi rahatlatıyor, hikâyenin kendiliğinden oluşmasına alan açıyoruz.
              </p>
            </div>
          </Reveal>
        )}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 mt-12 [column-fill:_balance]">
          {images.map((src, i) => (
            <button
              key={items[i].id || i}
              onClick={() => openAt(i)}
              data-testid="gallery-image-button"
              className="group relative mb-4 block w-full overflow-hidden rounded-2xl border border-white/8 break-inside-avoid"
            >
              <img
                src={thumbs[i]}
                alt={alts[i]}
                loading="lazy"
                className="w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                style={{ filter: "saturate(1.03) contrast(1.03)" }}
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors grid place-items-center">
                <Expand className="w-7 h-7 text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl bg-[#0E0F10] border-white/10 p-2 sm:p-3">
          <div className="relative">
            {images[index] && (
              <img src={images[index]} alt={alts[index]} className="w-full max-h-[80vh] object-contain rounded-lg" />
            )}
            <button onClick={prev} aria-label="Önceki"
              className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 grid place-items-center rounded-full bg-black/50 text-white hover:bg-black/70">
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button onClick={next} aria-label="Sonraki"
              className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 grid place-items-center rounded-full bg-black/50 text-white hover:bg-black/70">
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Gallery;
